import React from "react";
import MyApiKeysTable from "./MyApiKeysTable";
import { apiDocsUrl } from "../../../utils/apiServer";
import { ExternalLinkIcon, InfoIcon } from "../../../components/common/Icons/Icons";

interface ContainerProps {
  setGenerateOpen: any;
  setRevokeOpen: any;
  setSpaToModify: any;
}

const MyApiKeysContainer: React.FC<ContainerProps> = ({
  setGenerateOpen,
  setRevokeOpen,
  setSpaToModify,
}) => {
  // No filters here: the table takes the full width, with the API note in its toolbar
  const toolbar = (
    <span className="mk-note">
      <InfoIcon/>
      Use these keys to authorize requests to the public API.
      <a href={apiDocsUrl()} target="_blank" rel="noopener noreferrer" className="lp-link">
        View API documentation<ExternalLinkIcon/>
      </a>
    </span>
  );

  return (
    <MyApiKeysTable
      setGenerateOpen={setGenerateOpen}
      setRevokeOpen={setRevokeOpen}
      setSpaToModify={setSpaToModify}
      toolbar={toolbar}
    />
  );
};

export default MyApiKeysContainer;
